import { OnInit, ViewChild, Component } from "@angular/core";
import { MatTableDataSource, MatDialog } from "@angular/material";
import { SearchFilterComponent } from "../../../search-filter/search-filter.component";
import { Router } from "@angular/router";
import { AuthService } from "../../../../services/auth.service";
import { MenuService } from "../../../../services/menu.service";
import { CashDeskService } from "../../../../services/cash-desk.service";
import {
  SearchFilter,
  IFilterResponse,
} from "../../../../infrastructure/iFilter-component";
import { PatientCashDeskSeachItem } from "../../../../model/patient/patient-pending-cash-desk-search-item";
import { NotificationToastService } from "../../../../services/notification-toast.service";
import { PagerControlComponent } from "../../../controls/pager/pager-control.component";
import { InvoicePatientCashDeskService } from "src/app/services/invoice-cash-desk/invoice-patient-cash-desk.service";
import { PatientService } from "src/app/services/patient.service";
import { PatientMailEditDialogComponent } from "src/app/components/dialogs/patient-mail-edit-dialog/patient-mail-edit-dialog.component";

@Component({
  selector: "made-cash-desk-search",
  templateUrl: "./made-cash-desk-search.component.html",
  styleUrls: ["./made-cash-desk-search.component.css"],
})
export class MadeCashDeskSearchComponent implements OnInit {
  loading: boolean;
  patientPendingCashDeskSeachItem: PatientCashDeskSeachItem[] = [];
  searchFilters: SearchFilter[];
  displayedColumns: string[] = [
    "MedicalAppointmentDate",
    "InvoiceNumber",
    "InvoiceAmount",
    "Protocol",
    "PatientFullName",
    "Practice",
    "InvoiceTypeDescription",
    "Star",
  ];
  dataSource = new MatTableDataSource([]);
  @ViewChild("searchFilter", { static: false })
  searchFilter: SearchFilterComponent;
  @ViewChild("pager", { static: true }) pager: PagerControlComponent;

  constructor(
    public dialog: MatDialog,
    private router: Router,
    private invoicePatientCashDeskService: InvoicePatientCashDeskService,
    private menuService: MenuService,
    private patientService: PatientService,
    private notificationToastService: NotificationToastService
  ) {
    this.menuService.setMenuTitle("Cobranzas", "Realizadas");
  }

  ngOnInit(): void {}

  selectedPageIndexChange(pagedItems: any[]) {
    this.dataSource = new MatTableDataSource(pagedItems);
    this.loading = false;
  }

  onEndSearch(response: IFilterResponse<PatientCashDeskSeachItem>) {
    this.patientPendingCashDeskSeachItem = response.items;
    this.searchFilters = response.searchFilters;
    this.pager.setItems(this.patientPendingCashDeskSeachItem);
  }

  onStartSearch() {
    this.loading = true;
  }

  canGenerate(item: PatientCashDeskSeachItem): boolean {
    return !item.HasCreditNote && !item.IsCreditNote;
  }

  invoicePatientCashDeskRedirect(item: PatientCashDeskSeachItem): void {
    this.router.navigate([
      "invoice-patient-credit-note-cash-desk-edit",
      item.CashDeskInvoiceId,
      item.MedicalAppointmentId,
    ]);
  }

  invoicePatientCashDeskViewRedirect(item: PatientCashDeskSeachItem): void {
    this.router.navigate([
      "invoice-patient-cash-desk-view",
      item.CashDeskInvoiceId,
      item.MedicalAppointmentId,
    ]);
  }

  async sendMail(item: PatientCashDeskSeachItem) {
    try {
      const patientMail =
        await this.patientService.getPatientMailByAppointmentId(
          item.MedicalAppointmentId
        );

      const dialogRef = this.dialog.open(PatientMailEditDialogComponent, {
        width: "50%",
        data: patientMail,
      });

      const result = await dialogRef.afterClosed().toPromise();

      if (result) {
        await this.invoicePatientCashDeskService.sendMailPatientInvoiceCashDeskPdf(
          item.CashDeskInvoiceId,
          item.MedicalAppointmentId,
          null,
          result
        );
      }
    } catch (err) {
      console.log(err);
      this.notificationToastService.error(JSON.stringify(err.error), "Factura");
    }
  }
}
